import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-800 text-background-50">
      <div className="mx-auto max-w-page px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-accent-500 flex items-center justify-center text-background-50">
                <i className="ri-basketball-fill text-xl" />
              </span>
              <span className="font-heading text-lg font-bold tracking-wide">NBA直播吧</span>
            </div>
            <p className="text-sm leading-relaxed text-background-100/80">
              专注 NBA 篮球赛事的直播入口、实时比分与赛程资讯门户，为国内外篮球爱好者提供权威、及时的赛事信息。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">
              <span>快速导航</span>
            </h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-background-100/80 hover:text-accent-300 transition-colors cursor-pointer">赛事直播</Link></li>
              <li><Link to="/category/2025-2026" className="text-background-100/80 hover:text-accent-300 transition-colors cursor-pointer">赛程查询</Link></li>
              <li><Link to="/replays" className="text-background-100/80 hover:text-accent-300 transition-colors cursor-pointer">回放集锦</Link></li>
              <li><Link to="/teams" className="text-background-100/80 hover:text-accent-300 transition-colors cursor-pointer">球队与球员</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">
              <span>热门赛季</span>
            </h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/category/2025-2026" className="text-background-100/80 hover:text-accent-300 transition-colors cursor-pointer">2025-2026 赛季</Link></li>
              <li><Link to="/category/2024-2025" className="text-background-100/80 hover:text-accent-300 transition-colors cursor-pointer">2024-2025 赛季</Link></li>
              <li><Link to="/about" className="text-background-100/80 hover:text-accent-300 transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">
              <span>联系我们</span>
            </h4>
            <ul className="space-y-2 text-sm text-background-100/80">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line" />
                <span>feedback@nba-livebar.example</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line" />
                <span>每日 09:00 - 24:00 更新赛程</span>
              </li>
            </ul>
            <div className="mt-4 flex items-center gap-3">
              <span className="w-9 h-9 rounded-full bg-primary-700 flex items-center justify-center text-background-50">
                <i className="ri-wechat-line" />
              </span>
              <span className="w-9 h-9 rounded-full bg-primary-700 flex items-center justify-center text-background-50">
                <i className="ri-weibo-line" />
              </span>
              <span className="w-9 h-9 rounded-full bg-primary-700 flex items-center justify-center text-background-50">
                <i className="ri-youtube-line" />
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-700 pt-6 text-xs text-background-100/70 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 NBA直播吧 · 本网站为前端演示项目，赛事数据与视频均为示例内容</p>
          <p>本站与 NBA 官方无关联，所有商标归各自所有者所有</p>
        </div>
      </div>
    </footer>
  );
}